import React from 'react';

import {Lock as LockIcon} from '@mui/icons-material';
import {Stack, Typography} from '@mui/material';

import {Text} from 'components/index';
import {useUserUtils} from 'module/user/useUser';
import {useLayoutStore} from 'store';

const styles = {
    lockContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        padding: 2,
        boxSizing: 'border-box',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 0,
        zIndex: 10,
        textAlign: 'center',
    },
    lockContainerSmall: {
        position: 'absolute',
        bottom: '2px',
        right: '2px',
        zIndex: 10,
    },
    lockIcon: {
        color: 'white.main',
        width: '20px',
        height: '20px',
        marginBottom: '4px',
    },
};

const PremiumLock = ({text = '', small = false}) => {
    
    const {isAuthenticated} = useUserUtils();
    const setShowLogin = useLayoutStore((state) => state.setShowLogin);

    const containerStyle = small ? styles.lockContainerSmall : styles.lockContainer;

    if (!isAuthenticated) {
        return <Stack sx={containerStyle} onClick={() => setShowLogin(true)}>
            <Stack><LockIcon sx={styles.lockIcon} /></Stack>
            {!small && text !== '' && <Typography fontSize={13}><Text>account.page.login</Text></Typography> }
        </Stack>;
    }

    return <Stack sx={containerStyle}>
        <Stack><LockIcon sx={styles.lockIcon} /></Stack>
        {!small && text && <Typography fontSize={13}><Text>{text}</Text></Typography> }
    </Stack>;
};

export default PremiumLock;
